
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 2.5a8.956 8.956 0 018.085 5.042A8.956 8.956 0 0111 12.582a8.956 8.956 0 01-8.085-5.042A8.956 8.956 0 0111 2.5zm0-1.833C6.417.667 2.502 3.517.917 7.542c1.585 4.024 5.5 6.874 10.083 6.874s8.497-2.85 10.083-6.875C19.497 3.518 15.583.668 11 .668zm0 4.583a2.293 2.293 0 11-.002 4.585A2.293 2.293 0 0111 5.25zm0-1.833a4.131 4.131 0 00-4.125 4.125A4.131 4.131 0 0011 11.665a4.131 4.131 0 004.125-4.125A4.131 4.131 0 0011 3.417z","fill":"#BFBFBF"}})])
          )
        }
      }
    